import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M19.185 6H5.523c-.462 0-.677.523-.4.862l5.97 6.984c.184.216.276.523.276.8v4.43c0 .247.246.462.492.462h.924c.246 0 .43-.215.43-.461v-4.43c0-.309.123-.585.339-.8l6.03-6.985c.277-.339.062-.862-.4-.862z" /></svg>);